import { ROUTES } from '../constants/route-constants'

export const getBaseUrl = () => {
  const url = window.location
  if (!url.origin) {
    const port = url.port ? ':' + url.port : ''
    url.origin = url.protocol + '//' + url.hostname + port
  }
  return url.origin
}

export const getForceScanUrl = () => getBaseUrl() + ROUTES.FORCE_SCAN_API
export const getManifestInfoUrl = () => getBaseUrl() + ROUTES.MANIFEST_INFO_API
export const getMobileAppsUrl = () => getBaseUrl() + ROUTES.MOBILE_APPS_API
export const getProtectedPageUrl = () => getBaseUrl() + ROUTES.PROTECTED_PAGE_API
export const getQuantifiedSitesUrl = () => getBaseUrl() + ROUTES.QUANTIFIED_SITES_API
export const getSiteInfoUrl = () => getBaseUrl() + ROUTES.SITE_INFO_API
export const getProtectedPageRedirect = () => ROUTES.PROTECTED_PAGE_REDIRECT
export const getOldAuthNUrl = () => getBaseUrl() + ROUTES.OLD_AUTHN_URL
export const getUserInfoUrl = () => getBaseUrl() + ROUTES.USER_INFO_API
export const getDeveloperAPIUrl = () => getBaseUrl() + ROUTES.DEV_KEY_API



// WEBPACK FOOTER //
// ./src/utils/url-utils.js